import Link from 'next/link'
import Speaker from 'components/Speaker'
import { allSpeakers } from 'content/speakers'
import { Button, SEO } from '@martech/ig-summit-ui'

const SpeakersPage = () => {
  return (
    <>
      <SEO
        title="Instagram Summit 2022 | ManyChat | Speakers"
        keywords="speakers"
        description="speakers"
      />
      <div className="set-color" data-back="#ffdb28" data-front="#020202">
        <section className="m_t-xs m_b-xxl">
          <div className="m_x-xs">
            <Link href="/" className="text-action">
              ← back to homepage
            </Link>
            <h2 className="p_x-xs m_t-s text-center">Meet our speakers</h2>
          </div>
          <div className={`grid grid_2 t-grid_3 d-grid_4 gap-y m_t-xl`}>
            {allSpeakers.map((speaker) => (
              <Speaker speaker={speaker} key={speaker.firstName} />
            ))}
          </div>
          <div className="t-flex jcc m_x-xs m_t-xxl">
            <Button href="https://events.hubilo.com/igsummit-2022" target="_blank">
              Go to Summit
            </Button>
          </div>
        </section>
      </div>
    </>
  )
}

export default SpeakersPage
